import Challenge from '../components/challenge/Challenge';
import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getChallenges = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Challenge/GetChallengesByStudentNumber/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getChallengeById = async (id) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Challenge/GetChallengeById/${id}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const signUpForChallenge = async (signUpForm) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Challenge/SignUpForChallenge`,
        data: signUpForm,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const editTeamMember = async (editMember) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Challenge/EditTeamMember`,
        data: editMember,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getActivityAnswerHistoryById = async (memberId,id) => {
    return await axios({
        method:'GET',
        url :`${process.env.WEB_API}Activity/GetAnswerHistoryForActivity/${id}/${memberId}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    }).then(function (response){
        return response.data
    }).catch(function(error){
        console.error(error);
        return error.response.status;
    });
}

export const acceptChallenge = async (editMember) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Challenge/AcceptChallenge`,
        data: editMember,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getLeaderboardByChallengeId = async (challengeId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Challenge/GetLeaderboardByChallengeId/${challengeId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getClaimableChallengeReward = async (challengeId, teamId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Challenge/GetClaimableChallengeReward/${challengeId}/${teamId}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const claimChallengeReward = async (rewardModel) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Challenge/ClaimChallengeReward`,
        data: rewardModel,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};